import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Touramp from "../../assets/images/touramp.png";
import Button from "../../components/ui/button";
import Authentication from "../../utils/apiServices/authentication";
import notify from "../../utils/notify";
import { useLanguage } from "../../utils/useLanguage";
import { login } from "../login/reducer";
import { generateToken, zimLoginSafe } from "../../utils/chat";
import { setChat } from "../chat/reducer";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const token = searchParams.get("token");
    const email = searchParams.get("email");

    if (!token || !email) {
      notify("error", "Invalid verification link");
      navigate("/login");
      return;
    }

    setLoading(true);
    Authentication.verify({
      email: decodeURIComponent(email),
      token: token,
    })
      .then((res) => {
        if (res.success) {
          setVerified(true);
          notify("success", res.message || "Email verified successfully");

          const data = res.data ?? res;
          const accessToken =
            data.token?.token ??
            data.access_token ??
            (typeof data.token === "string" ? data.token : null);
          const user = data.user;

          if (accessToken && user) {
            dispatch(
              login({
                id: user.id,
                country: user.country,
                firstname: user.firstname,
                lastname: user.lastname,
                phone: user.phone,
                email: user.email,
                image: user.image,
                is_phone_verified: user.is_phone_verified,
                email_verified_at: user.email_verified_at,
                interest: user.interest,
                device_token: user.device_token,
                status: user.status,
                order_count: user.order_count,
                login_medium: user.login_medium,
                social_id: user.social_id,
                user_id: user.user_id,
                zone_id: user.zone_id,
                wallet_balance: user.wallet_balance,
                ref_code: user.ref_code,
                ref_by: user.ref_by,
                temp_token: user.temp_token,
                account_status: user.account_status,
                created_at: user.created_at,
                updated_at: user.updated_at,
                delete_at: user.delete_at,
                access_token: accessToken,
                loggedIn: true,
                remember_me: true,
              })
            );
            const userId = user.id?.toString() ?? "";
            const userName = `${user.firstname || ""} ${user.lastname || ""}`.trim();
            if (userId && userName) {
              zimLoginSafe(
                { userName, userID: userId },
                generateToken(userId, 0)
              ).then((ok) => {
                if (!ok) return;
                dispatch(setChat({ isLogged: true, isLoading: false }));
              });
            }
            navigate("/");
          } else {
            setTimeout(() => navigate("/login"), 2000);
          }
        } else {
          notify("error", res.message || "Verification failed");
          setTimeout(() => navigate("/login"), 2000);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Verification error:", error);
        notify("error", "An error occurred during verification");
        setLoading(false);
        setTimeout(() => navigate("/login"), 2000);
      });
  }, [searchParams, navigate, dispatch]);

  return (
    <div className="min-h-screen scrollbar">
      <div className="flex flex-col text-black md:px-20 px-4 py-10 md:py-10">
        <img
          src={Touramp}
          alt=""
          className="w-20 md:w-32 cursor-pointer py-5"
          onClick={() => navigate("/home")}
        />
        <div className="text-xl md:text-2xl font-bold py-2">
          {verified ? "Email Verified!" : "Verifying Email..."}
        </div>
        <div className="text-sm md:text-base font-normal">
          {verified
            ? "Your email has been verified successfully. Redirecting to dashboard..."
            : "Please wait while we verify your email..."}
        </div>
        {loading && (
          <div className="flex justify-center mt-5">
            <Button label="Verifying..." loading={loading} disabled={true} onClick={() => {}} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;